export default __webpack_public_path__ + "static/media/Asia.6f008e98.png";